import { Container } from 'pixi.js';

export class Scene<T> extends Container {
  /**
   * Scene arguments.
   */
  protected readonly arg: T;

  public constructor(arg: T) {
    super();
    this.arg = arg;
  }

  /**
   * Path list of assets that used in scene.
   */
  public static get assets(): string[] {
    return [];
  }

  /**
   * Run on entering scene. (after adding scene to stage)
   */
  public async setUp(): Promise<void> {
    throw new Error('"setUp" must be implemented.');
  }

  /**
   * Run on opening scene. (after loading finish event)
   */
  public async open(): Promise<void> {}

  /**
   * Run on closing scene. (before loading start event)
   */
  public async close(): Promise<void> {}

  /**
   * Run on exitting scene. (before removing scene to stage)
   */
  public async tearDown(): Promise<void> {}
}
